// @flow

import React from 'react'
import { renderToString } from 'react-dom/server';
import { connect } from 'react-redux'
import bindAll from 'lodash/bindAll'
import { List, Map, fromJS } from 'immutable'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import moment from 'moment'
import PaginationSupport from '../partials/PaginationSupport'
import $ from 'jquery'

import {
	assessmentFetchData,
	assessmentsAddFilterPageNumber,
	assessmentsAddFilterSearch,
	companiesAddFilterSort,
	companiesAddFilterName,
	assessmentsAddFilterColPerPage,
	companiesAddFilterStatus,
	assessmentClearFilterData,
	companiesAddFilterChannel
} from '../../actions/assessment'

import ModalDownloadAllAccounts from '../partials/ModalDownloadAllAccounts'
import ModalConnectPopskul from '../partials/ModalConnectPopskul'

import TableLoader from '../partials/TableLoader'

require('es6-promise').polyfill()

type Props = {
	assessmentFetchData: Function,
	assessmentFetchDataAsync: Function,
	assessmentsPagination: Map<string, any>,
	companies: List<Map<string, any>>,
	companiesFilterData: Map<string, any>,
	assessmentsAddFilterPageNumber: Function,
	globalIndicatorData: Map<string, any>,
	assessmentsAddFilterSearch: Function,
	companiesAddFilterSort: Function,
	companiesAddFilterName: Function,
	assessmentsAddFilterColPerPage: Function,
	companiesAddFilterStatus: Function,
	companiesAddFilterChannel: Function,
};

type State = {
	isShown: boolean
};

class AssessmentList extends React.Component<Props, State> {
	state: State;

	constructor(props) {
		super(props)

		this.state = {
			isShown: false,
			selectedCompany:{}
		}

		bindAll(this, [
			'handleSortChange',
			'handleSearchByName',
			'handleChangePageSize',
			'handleFilterByStatus',
			'handleModalDownload',
			'creditFormatter',
			'titleFormatter',
			'handleSelectRow',
			'dateFormatter',
			'popskulActionFormater',
			'handleConnectDisconnectPopskul',
			'onCloseModal'
		])
	}

	componentDidMount() {
		const {
			assessmentFetchData,
			assessmentClearFilterData,
			assessmentFilterData
		} = this.props

		let prevState = this.props.location.state
		
		assessmentClearFilterData()
		.then(()=>{
				assessmentFetchData(this.props.assessmentFilterData)
		})
		
	}

	handleModalDownload(e: Object){
		e.preventDefault()

		$('#modalDownloadAllAccounts').modal('show')
	}

	handleChangePageSize(e): void{
		const{
			assessmentsAddFilterPageNumber,
			assessmentFetchData,
			assessmentsAddFilterColPerPage,
		}=this.props

		const countFilter = e.target.value
		assessmentsAddFilterPageNumber(1)
		.then(()=>{
			assessmentsAddFilterColPerPage(countFilter)
			.then(()=>{
				assessmentFetchData(this.props.assessmentFilterData)
			})
		})

	}

	handleSortChange(name, order){
		const {
			assessmentFetchData,
			companiesAddFilterSort
		} = this.props

		let sort={
			name: name,
			value: order
		}

		companiesAddFilterSort(sort).then(()=>assessmentFetchData(this.props.companiesFilterData))

	}

	handleSearchByName(event){
		const{
			assessmentsAddFilterPageNumber,
			assessmentFetchData,
			assessmentsAddFilterSearch
		}=this.props

		let keywords=event.target.value
		if (event.charCode === 13) {
			assessmentsAddFilterPageNumber(1).then(()=>{
				assessmentsAddFilterSearch(keywords).then(()=>{
					assessmentFetchData(this.props.assessmentFilterData)
				})
			})
    	}
	}

	handleFilterByStatus(event){
		const{
			assessmentsAddFilterPageNumber,
			assessmentFetchData,
			companiesAddFilterStatus
		}=this.props

		let status=event.target.value
		assessmentsAddFilterPageNumber(1).then(()=>{
			companiesAddFilterStatus(status).then(()=>{
				assessmentFetchData(this.props.companiesFilterData)
			})
		})
	}

	creditFormatter(cell: Object, row: Object): Object {
		let colorText='text-red'
		let credit = parseInt(row.candidate_credit);
		let creditUsed = parseInt(row.credit_used);
		let creditText = `${credit-creditUsed}/${creditUsed}`
		if(row.status==='Active'){
			colorText='text-green'
			creditText = row.credit_left;
		}
		return <span className={colorText}>{creditText}</span>
	}

	dateFormatter(cell: Object, row: Object): Object {
		let date = (row.latest_update ? moment(row.latest_update).format('MMM DD, YYYY hh:mm A') +' (UTC)'  : '')
		return <span>{date}</span>
	}
	
	handleSelectRow(row, index){
		
			this.props.history.push({ 
				pathname: `/support/assessment-dashboard/${row.assessment_name}`,
				state: {prevPage: 'assessment-dashboard'}
			})
		
	}

	titleFormatter(cell: Object, row: Object): Object {
		return <div>
		  <span><a onClick={(e)=>this.handleSelectRow(row)}>{row.name}</a></span>
	  </div>						
	}

	purifyData(data){
		const sanitize_data = data.map((value,index)=>{
			 value.title = renderToString(value.title)
			 value.administrator = renderToString(value.administrator)
			 value.email = renderToString(value.email)
			 return value
		})

		return sanitize_data;
	}

	popskulActionFormater(cell, row){
		const {
			userPrivilege, 
			userAuth
		} = this.props

		// let itSelf=userAuth.get('id')==row.id ? true : false
		// let myPrivilege=['UPDATE_USER','ACTIVATE_USER','RESET_USERS_PASSWORD','VISIT_USERS_DASHBOARD','SEND_EMAIL_TO_USERS','DELETE_USERS']
		// let res = userPrivilege.filter(item => myPrivilege.includes(item));
		
		// if(itSelf || res.length<1){
		// 	return null
		// }
		let buttonLabel = 'Connect'
		let buttonClass = 'button__primary'
		console.log('b', row);
		if(row.popskul_connection==1){
			buttonLabel = 'Disconnect'
			buttonClass = 'button__secondary'
		}
		return <button onClick={(e)=>this.handleConnectDisconnectPopskul(e, row)} className={`button ${buttonClass}`}>{buttonLabel}</button>
	}

	handleConnectDisconnectPopskul(e, company){
		e.preventDefault()
		this.setState({selectedCompany:company})
		$('#modalConnectPopskul').modal('show')
	}

	onCloseModal(){
		this.setState({selectedCompany:{}})
		this.props.assessmentFetchData(this.props.companiesFilterData)
	}

  	render() {
		const {
			companies,
			assessmentsPagination,
			assessmentsAddFilterPageNumber,
			assessmentFilterData,
			assessmentFetchData,
			globalIndicatorData,
			assessments,
		} = this.props

		let reportPagination: ?Object

		if (!assessments.isEmpty()) {
			reportPagination =
				<PaginationSupport
					pagination={assessmentsPagination}
					fetchData={assessmentFetchData}
					filterData={assessmentFilterData}
					addPageNumber={assessmentsAddFilterPageNumber} />
		}

		const isIndicatorClass = globalIndicatorData.get('isShow')? 'p-t-56' : ''
		const options = {
			onSortChange: this.handleSortChange,
			onRowClick: (row, columnIndex)=>this.handleSelectRow(row, columnIndex),
			noDataText: <TableLoader isFetched={this.props.isFetched}/>
		};
    	return (

			<div className={isIndicatorClass}>
	      		<div className="div-support-container table">
	        		<section className="wrapper">
	          			<div className="main-content">
	            			<div className="container-fluid">
	              				<div className="big-panel">
									<div className="flex-container">
										<h5 className="title-heading">Assessment Dashboard</h5>
									</div>

									<div className="flex-container flex-between">
										<div className="flex-container vertical-item--center">
											Show
											<select
												className="select-status-user"
												name="status"
												id="status"
												value={assessmentFilterData.get('per_page')}
												onChange={(e)=>this.handleChangePageSize(e)}>
												<option value="10" >10</option>
												<option value="20" >20</option>
												<option value="30" >30</option>
										  	</select>
										 	 Entries
										 
										 
										</div>
										<div className="search-support-container horizontal-item--between">
											<input className="search-support" placeholder="Search" defaultValue={this.props.assessmentFilterData.get('search')} onKeyPress={this.handleSearchByName}/>
												<i className="fa fa-search"></i>
										</div>
									</div>

												<div className="report-list-container assessment-container form-custom support-company-list">
										<BootstrapTable
											data={this.purifyData(this.props.assessments.toJS())}
											striped={true}
											options={options}
											hover
										>
											<TableHeaderColumn dataFormat={this.titleFormatter} dataField="name" isKey={true} dataSort={true}>Assessment</TableHeaderColumn>
											<TableHeaderColumn dataFormat={this.dateFormatter} dataField="latest_update" dataSort={false}>Last Update</TableHeaderColumn>
											
										</BootstrapTable>
										{reportPagination}
	                				</div>
	              				</div>
	            			</div>
	          			</div>
	        		</section>
	      		</div>
	      		<ModalDownloadAllAccounts />
				<ModalConnectPopskul company={this.state.selectedCompany} onCloseModal={this.onCloseModal}/>
			</div>
    	)
  	}
}

const mapStateToProps = (state, ownProps) => {
  const assessmentData =fromJS([
    {
      'title':'Value Reflect Assessment(VRA)',
      'updated_at':'2025-04-16 03:38:28',
    },
    {
      'title':'Creative Thinking Assessment(CTA)',
      'updated_at':'2025-03-15 03:38:28'
    }
  ]) 

	return {
		// example
    assessmentData:assessmentData,
		// end of example data
		companies: state.companies,
		companiesFilterData: state.companiesFilterData,
		companiesIsLoading: state.companiesIsLoading,
		globalIndicatorData: state.globalIndicatorData,
		isFetched: state.isFetched,
		assessmentFilterData:state.assessmentFilterData,
		assessments: state.assessments,
		assessmentsPagination:state.assessmentsPagination,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		assessmentFetchData: (filter_data) => dispatch(assessmentFetchData(filter_data)),
		assessmentsAddFilterPageNumber: (page) => dispatch(assessmentsAddFilterPageNumber(page)),
		assessmentsAddFilterSearch: (search) => dispatch(assessmentsAddFilterSearch(search)),
		companiesAddFilterSort: (sort) => dispatch(companiesAddFilterSort(sort)),
		companiesAddFilterName: (name) => dispatch(companiesAddFilterName(name)),
		assessmentsAddFilterColPerPage: (col) => dispatch(assessmentsAddFilterColPerPage(col)),
		companiesAddFilterStatus: (status) => dispatch(companiesAddFilterStatus(status)),
		assessmentClearFilterData: () => dispatch(assessmentClearFilterData()),
		companiesAddFilterChannel: (channel) => dispatch(companiesAddFilterChannel(channel)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentList)
